import type { ContactItem } from '../types';

export const contact: readonly ContactItem[] = [
  { label: 'Email', value: 'me@denqxotl.com', href: 'mailto:me@denqxotl.com', kbd: 'E' },
  { label: 'Telegram', value: '@denqxotl', href: 'https://t.me/denqxotl', kbd: 'T' },
  { label: 'GitHub', value: 'github.com/denqxotl', href: 'https://github.com/denqxotl', kbd: 'G' },
  { label: 'LinkedIn', value: 'linkedin.com/in/denqxotl', href: 'https://www.linkedin.com/in/denqxotl/', kbd: 'L' },
  { label: 'Phone', value: '+48 572 260 207', href: 'tel:+48572260207', kbd: 'P' },
];
